import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'


const url = store.getters.getPostUrl;
export default {
  selectEquipmentById(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentMonitoringService/selectEquipmentAll',
      method: 'post',
      data: param
    })
  },
  selectEfficency(param){
    return request({
      url: store.getters.getPostUrl + 'mes/signal/selectEfficency',
      method: 'post',
      data: param
    })
  },
  selectSignal(param){
    return request({
      url:store.getters.getPostUrl + 'mes/signal/selectSignal',
      method:'post',
      data : param
    })
  },
  selectSignalColor() {
    return request({
      url: store.getters.getPostUrl + 'mes/signal/selectSignalColor',
      method: 'get'
    })
  },
  // getFactoryTypeList() {
  //   return request({
  //     url: store.getters.getPostUrl + 'mes/dict/ByDictIdALL?dictId=1',
  //     method: 'get'
  //   })
  // },

}



// WEBPACK FOOTER //
// ./src/assets/js/signal/signal.js